<script>
// import appConfig from '@src/app.config.json'
import Axios from '@plugin/axios.js'
import { BIconSearch } from 'bootstrap-vue'

export default {
  components: {
    BIconSearch,
  },
  data() {
    return {
      // menuItems: null,
      Main: [],
      Secondary: [],

      isChildMenuActive: 0,
      hasChildMenu: null,
      /** language switcher global */
      lang: localStorage.getItem('lang') ? localStorage.getItem('lang') : 'id',
      /** when navbar scrolled certain px */
      scrollpx: 0,
      lastScrolled: 0,
      // then fix the navbar position
      navbarFixed: false,
      navbarRemove: true,
      navbarLoading: false,
      form: {
        q: '',
        klaster: '',
      },
      param: this.$route.query,
      currentPath: window.location.pathname,
      currentUrl: window.location.origin + window.location.pathname,
      // mobile devices
      mobileMenuState: global.app.mobileMenuState,
      // mobileMenuState: false,
      animateMenu: false,
      isMobile: false,
      menuHeight: 0,
      currentPage: '',
    }
  },
  watch: {
    isChildMenuActive: function() {
      this.getChildMenu()
    },
    lang: function(lang) {
      global.app.lang = lang
      this.getMenu()
      this.getMenu('Secondary')
    },
    $route(to, from) {
      const exclude = [
        'homepage',
        'legal-analysis-single',
        'data-center-single',
        'academic-journal-single',
        'news-single',
        'contact',
        'kontak',
        'tentang-kami',
        'about-us',
      ]
      if (!exclude.includes(to.name)) {
        this.currentPage = to.name
      } else {
        this.currentPage = ''
      }
      if (this.form.klaster !== 'search' && this.currentPage !== 'search') {
        this.form.klaster = to.name
      } else {
        delete this.form.klaster
      }
      if (this.currentPath !== to.fullPath) {
        this.currentPath = from.fullPath
        this.mobileMenuState = false
        global.app.mobileMenuState = false
        this.animateMenu = false
        document.getElementsByTagName('body')[0].classList.remove('hold')
      }
    },
  },
  async mounted() {
    await this.getMenu()
    await this.getMenu('Secondary')
    this.checkMobile()
    this.currentPage = this.currentPath.substring(1)
    if (this.form.klaster !== 'search' && this.currentPage !== 'search') {
      this.form.klaster = this.currentPath.substring(1)
    } else {
      delete this.form.klaster
    }
    this.menuHeight = window.innerHeight
  },
  created() {
    window.addEventListener('scroll', this.handleScroll)
  },
  destroyed() {
    window.removeEventListener('scroll', this.handleScroll)
  },
  methods: {
    getMenu: function(location = 'Main') {
      /** define ANY API prequisite */
      var params = {
        klaster_slug: 'menu',
        attribute_show: false,
        taxonomy_show: false,
        lang: this.lang,
        simple: true,
      }
      /** loop param then push to params */
      var param = {
        attribute: {
          section: location,
        },
      }
      /** params need to encoded from object to url params */
      params = this.generateParams(params, param)
      /** define endpoint */
      var endpoint = `klaster-by-member-relation?${params}`
      Axios.get(endpoint).then((response) => {
        const data = response.data.data
        if (data) {
          this[location] = data
        }
      })
    },
    toggleChildMenu: function(el) {
      this.isChildMenuActive = el
    },
    getChildMenu: function() {
      // get ID from active menuItem
      var menuId = this.isChildMenuActive
      /**
       * get child menu(s) from active ID on menuItems
       * i don't know why but the index is +1, so we -1 to make it equal
       * to its active ID
       */
      var childMenus = this.Main[menuId - 1]
      // check if menu has childs
      try {
        if ('childs' in childMenus) {
          this.hasChildMenu = JSON.parse(JSON.stringify(childMenus.childs))
        } else {
          // hide the childs menu container
          this.isChildMenuActive = 0
        }
      } catch (error) {
        // hide the childs menu container
        this.isChildMenuActive = 0
      }
    },
    langSwitcher: function(to) {
      // save to local storage
      localStorage.setItem('lang', to)
      this.lang = to
      global.app.lang = to
      // console.log(this.$route)
      this.$router.push({
        path: this.$route.fullPath,
        query: { lang: to },
      })
    },
    handleScroll: function() {
      this.scrollpx = window.scrollY
      if (this.scrollpx > 75 && this.scrollpx < this.lastScrolled) {
        this.navbarFixed = true
        this.navbarRemove = false
      } else {
        this.navbarFixed = false
        this.navbarRemove = true
      }
      // remove class when user hit 75px from top
      this.lastScrolled = this.scrollpx
    },
    /**
     * Mobile Devices
     */
    openMenu: function() {
      this.mobileMenuState = !this.mobileMenuState
      global.app.mobileMenuState = !global.app.mobileMenuState
      this.animateMenu = global.app.mobileMenuState
      if (this.mobileMenuState) {
        document.getElementsByTagName('body')[0].classList.add('hold')
      } else {
        document.getElementsByTagName('body')[0].classList.remove('hold')
      }
    },
    checkMobile() {
      if (
        /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
          navigator.userAgent
        )
      ) {
        this.isMobile = true
      } else {
        this.isMobile = false
      }
    },
    // search from on submit
    search(evt) {
      evt.preventDefault()
      // go to search page with params
      this.$router.push({ path: '/search', query: this.form })
    },
  },
}
</script>

<template>
  <div id="navigation">
    <div
      v-show="navbarFixed === true"
      :style="{ minHeight: isMobile ? '60px' : 'calc(106px + 48px)' }"
    ></div>
    <b-navbar
      toggleable="lg"
      type="light"
      :class="[
        navbarFixed === true
          ? $style.navbarFixed
          : navbarRemove === false
          ? $style.navbarScrolled
          : '',
        $style.mainNavbar,
      ]"
    >
      <b-container>
        <b-navbar-brand :to="'/'">
          <img
            src="@assets/images/Logo_500px.png"
            alt="lexikan-logo"
            :class="$style.brandLogo"
          />
        </b-navbar-brand>

        <button
          class="hamburger hamburger--collapse d-block d-lg-none"
          :class="[$style.mobileMenuButton, mobileMenuState ? 'is-active' : '']"
          type="button"
          @click="openMenu"
        >
          <span class="hamburger-box">
            <span class="hamburger-inner"></span>
          </span>
        </button>

        <div
          id="mobileMenuToggler"
          :class="[
            $style.mobileMenu,
            mobileMenuState ? $style.show : $style.hide,
            animateMenu ? 'animated slideInRight' : '',
          ]"
          class="d-lg-none d-sm-block"
          style="animation-duration: 0.5s"
          :style="{ height: menuHeight + 100 + 'px' }"
        >
          <div :class="$style.menuHeader" class="mt-5">
            <b-dropdown
              id="dropdown-1"
              :text="lang === 'en' ? 'English' : 'Bahasa Indonesia'"
              variant="light"
              class="m-md-2"
              :class="[$style.langSwitcherMobile, $style.langSwitcher]"
            >
              <b-dropdown-item
                :class="[
                  lang === 'id' ? $style.active : '',
                  $style.langSelectorButton,
                ]"
                @click="langSwitcher('id')"
                >Bahasa Indonesia</b-dropdown-item
              >
              <b-dropdown-item
                :class="[
                  lang === 'en' ? $style.active : '',
                  $style.langSelectorButton,
                ]"
                @click="langSwitcher('en')"
                >English</b-dropdown-item
              >
            </b-dropdown>
          </div>
          <ul
            class="container"
            :class="[
              $style.mobileMenuContainer,
              navbarFixed === true ? $style.navbarFixed : '',
            ]"
          >
            <li class="mb-3">
              <form class="d-block" @submit="search">
                <div class="position-relative">
                  <!-- eslint-disable -->
                  <input
                    v-model="form.q"
                    type="text"
                    name="q"
                    class="form-control"
                    :placeholder="
                      param.q
                        ? 'searching: ' + param.q
                        : $t('search') +
                          ' ' +
                          $t(
                            currentPage.split('-').join(' ') !== 'homepage' &&
                              currentPage.split('-').join(' ')
                          )
                    "
                    :class="$style.searchInput"
                  />
                  <!-- eslint-enable -->
                  <router-link
                    :to="
                      `/search?q=${form.q}${
                        currentPage !== '' ? '&klaster=' + currentPage : ''
                      }`
                    "
                    style="display: contents"
                  >
                    <BIconSearch
                      :class="$style.searchIcon"
                      class="position-absolute"
                      :style="{
                        top: '50%',
                        right: 0,
                        transform: 'translate(0, -25%)',
                      }"
                      pointer
                    ></BIconSearch>
                  </router-link>
                </div>
              </form>
            </li>
            <li
              v-for="(item, ID) in Main"
              :key="ID"
              :class="isChildMenuActive === item.ID ? $style.active : ''"
              @mouseover="toggleChildMenu(item.ID)"
              @click="toggleChildMenu(item.ID)"
            >
              <router-link
                :to="'/' + item.slug"
                :style="{ color: '#000', textDecoration: 'none' }"
                replace
              >
                {{ item.title }}
              </router-link>
            </li>
          </ul>
          <div :class="$style.menuFooter">
            <b-nav-form>
              <router-link
                v-for="(menu, index) in Secondary"
                :key="index"
                class="mr-3"
                :to="{ path: '/' + menu.slug }"
                >{{ menu.title }}</router-link
              >
            </b-nav-form>
          </div>
        </div>

        <div
          id="nav-collapse"
          class="d-none d-lg-flex"
          :class="[$style.navbarCollapse]"
          is-nav
        >
          <b-navbar-nav>
            <b-nav-item
              v-for="(menu, index) in Secondary"
              :key="index"
              :to="{ path: '/' + menu.slug }"
              :class="$style.navItem"
              >{{ menu.title }}</b-nav-item
            >
          </b-navbar-nav>

          <!-- Right aligned nav items -->
          <b-navbar-nav class="ml-auto">
            <b-nav-form @submit="search">
              <div :class="$style.searchWrapper">
                <!-- eslint-disable -->
                <input
                  v-model="form.q"
                  type="text"
                  name="q"
                  class="form-control"
                  :placeholder="
                    param.q
                      ? 'searching: ' + param.q
                      : $t('search') +
                        ' ' +
                        $t(
                          currentPage.split('-').join(' ') !== 'homepage' &&
                            currentPage.split('-').join(' ')
                        )
                  "
                  :class="$style.searchInput"
                />
                <!-- eslint-enable -->
                <router-link
                  :to="
                    `/search?q=${form.q}${
                      currentPage !== '' ? '&klaster=' + currentPage : ''
                    }`
                  "
                  style="display:contents"
                >
                  <BIconSearch :class="$style.searchIcon" pointer></BIconSearch>
                </router-link>
              </div>
            </b-nav-form>

            <b-nav-form class="ml-4">
              <b-dropdown
                id="dropdown-1"
                :text="lang === 'en' ? 'English' : 'Bahasa Indonesia'"
                variant="light"
                class="m-md-2"
                :class="$style.langSwitcher"
              >
                <b-dropdown-item
                  :class="[
                    lang === 'id' ? $style.active : '',
                    $style.langSelectorButton,
                  ]"
                  :href="'?lang=id'"
                  @click.native="langSwitcher('id')"
                  >Bahasa Indonesia</b-dropdown-item
                >
                <b-dropdown-item
                  :class="[
                    lang === 'en' ? $style.active : '',
                    $style.langSelectorButton,
                  ]"
                  :href="'?lang=en'"
                  @click.native="langSwitcher('en')"
                  >English</b-dropdown-item
                >
              </b-dropdown>
            </b-nav-form>
          </b-navbar-nav>
        </div>
      </b-container>
    </b-navbar>
    <nav
      v-if="isMobile === false"
      :class="[$style.menu, navbarFixed === true ? $style.navbarFixed : '']"
    >
      <ul class="container" :class="[$style.menuContainer]">
        <li
          v-for="(item, ID) in Main"
          :key="ID"
          :class="[isChildMenuActive === item.ID ? $style.active : '']"
          @mouseover="toggleChildMenu(item.ID)"
          @click="toggleChildMenu(item.ID)"
        >
          <router-link
            :to="'/' + item.slug"
            :style="{ color: '#fff', textDecoration: 'none' }"
            replace
          >
            {{ item.title }}
          </router-link>
        </li>
      </ul>

      <b-container
        v-if="isChildMenuActive"
        :class="$style.childMenuWrapper"
        @mouseleave="isChildMenuActive = false"
      >
        <ul v-if="hasChildMenu" :class="$style.childMenuContainer" class="row">
          <li
            v-for="(child, ID) in hasChildMenu"
            :key="ID"
            :class="$style.childMenuItems"
          >
            <router-link :to="item.title">
              {{ child.title }}
            </router-link>
          </li>
        </ul>
      </b-container>
    </nav>
  </div>
</template>

<style lang="scss">
@import '@cssVendor/hamburgers/hamburgers.min';
[class~='hamburger-box'] {
  width: 2rem;
  height: 23px;
  [class~='hamburger-inner'] {
    width: 2rem;
    height: 4px;
    background-color: var(--primary) !important;
    &::before,
    &::after {
      width: 2rem;
      height: 4px;
      background-color: var(--primary) !important;
    }
  }
}
</style>

<style lang="scss" module>
@import '@design';

.mainNavbar {
  z-index: 1024;
  padding: 0.5rem 1rem;
  // transition: 0.3s ease-in-out;
  [class~='navbar-toggler'] {
    z-index: 1;
    padding: 0;
    border: none;
  }

  /**
  * When user scrolling to top then show
  */
  &.navbarFixed {
    position: fixed;
    top: 0;
    width: 100vw;
    visibility: visible;
    background: #fff;
    box-shadow: 0 0 20px rgba(0, 0, 0, 0.1);
    // transition: all 0.5s ease-in-out;
    // animation-name: slideDown;
    // animation-duration: 0.3s;
    // animation-timing-function: ease;
  }

  &.navbarRemoved {
    transform: translateY(-75px);
  }

  /*
  * when user scrolling to bottom then hide
  */
  &.navbarScrolled {
    position: fixed;
    width: 100%;
    // transition: all 0.2s ease-in-out;
    transform: translateY(-200%);
  }

  .brandLogo {
    width: 10rem;
  }
  .navbarCollapse {
    display: flex;
    align-items: center;
    width: 100%;
    &.show {
      position: absolute;
      top: 0;
      right: 0;
      width: 90%;
      height: 100vh;
      background: #fff;
      animation-name: slideDown;
      animation-duration: 0.3s;
      animation-timing-function: ease;
    }
  }
  .searchWrapper {
    position: relative;
    .searchIcon {
      position: absolute;
      top: 0.75rem;
      right: 0.5rem;
      color: $primary;
    }
    .searchInput {
      padding-right: 2rem;
      padding-left: 0.5rem;
      font-style: italic;
      border: none;
      border-bottom: 1px solid $primary;
      border-radius: 0;
      &::placeholder {
        color: $primary;
      }
      &:focus {
        box-shadow: none;
      }
    }
  }
  // language selector button
  .langSwitcher {
    border: 2px solid rgba(0, 0, 0, 0.25);
    border-radius: $radius / 2;
    ul[role='menu'] {
      width: 100%;
      &:focus {
        outline: none !important;
      }
    }
    .langSelectorButton {
      color: rgba(0, 0, 0, 0.5);
      background: $white;
      border: none;
      &:hover {
        background-color: #fbfbfb;
      }
      &:focus {
        border: none;
        box-shadow: none;
      }
      &.active,
      &:active {
        font-weight: 600;
        color: $primary !important;
        background-color: #fff !important;
      }
    }
  }
  .navItem {
    a {
      @extend %typography-medium;

      font-weight: $medium;
      color: #000 !important;
    }
  }
}
.menu {
  width: 100%;
  height: 3rem;
  background-color: $primary;
  .menuContainer {
    display: flex;
    justify-content: space-between;
    height: 100%;
    margin: 0 auto;
    overflow-x: auto;
    li {
      @extend %typography-medium;

      position: relative;
      display: flex;
      align-items: center;
      align-self: center;
      height: 100%;
      padding-right: 0.75rem;
      padding-left: 0.75rem;
      font-weight: $medium;
      color: #fff;
      list-style: none;
      &:active,
      &:hover,
      &.active {
        cursor: pointer;
        background-color: #2678ae;
        // transition: all 0.3s ease-in-out;
        &::after {
          position: absolute;
          bottom: 0.5rem;
          left: 50%;
          width: 25%;
          content: '';
          border-bottom: 2px solid #fff;
          transform: translate(-50%);
        }
      }
    }
  }
  &.navbarFixed {
    position: fixed;
    top: 6.5rem;
    z-index: 5;
    box-shadow: 0 10px 10px rgba(0, 0, 0, 0.15);
    // transition: all 0.3s ease-in-out;
    // animation-name: slideDown;
    // animation-duration: 0.3s;
    // animation-timing-function: ease;
  }
}

.childMenuWrapper {
  position: absolute;
  right: 0;
  left: 0;
  z-index: 1024;
  margin-right: auto;
  margin-left: auto;
  text-align: center;
  transform: translate(1rem);
  .childMenuContainer {
    width: 100%;
    padding: 1rem;
    background-color: $white;
    border-bottom-right-radius: 15px;
    border-bottom-left-radius: 15px;
    box-shadow: 1px 3px 5px rgba(0, 0, 0, 0.1);
    .childMenuItems {
      flex: 0 0 25%;
      max-width: 25%;
      padding: 0.5rem 1.25rem;
      font-weight: 600;
      list-style: none;
      a {
        color: #000;
        text-decoration: none;
        transition: all 0.25s ease-in-out;
        &:hover {
          color: $primary;
        }
      }
    }
  }
}

/**
* For mobile devices
*/
@media screen and (max-width: $mobile-sm) {
  .mainNavbar {
    padding: 1rem;
    .brandLogo {
      width: 5rem;
    }
  }
  .mobileMenuButton {
    position: absolute;
    top: 1.5rem;
    right: 2rem;
    z-index: 1;
    padding: 0;
    &:focus {
      outline: none;
    }
  }
  .mobileMenu {
    &.show,
    &.hide {
      position: absolute;
      top: 0;
      right: 0;
      display: flex;
      flex-direction: column;
      align-items: center;
      width: 90vw;
      height: 100vh;
      padding: 2rem;
      background-color: $white;
      box-shadow: 0 0 15px rgba(0, 0, 0, 0.5);
    }
    &.hide {
      right: -90vw;
      box-shadow: none;
      // transition: all 0.3s ease-in-out;
    }
    .mobileMenuContainer {
      padding-left: 0;
      margin: 1rem 0;
      li {
        width: 100%;
        padding: 0.25rem 0;
        font-size: 1.25em;
        list-style: none;
      }
    }
    .menuFooter,
    .menuHeader {
      width: 100%;
      .langSwitcherMobile {
        width: 100%;
      }
    }
  }
}

/** end of mobile styling */

// hide animation for mobile menu
@keyframes hideRight {
  0% {
    right: -90vw;
  }
  100% {
    display: none;
  }
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
@keyframes slideDown {
  0% {
    transform: translateY(-100%);
  }
  100% {
    transform: translateY(0%);
  }
}
</style>
